import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

class ModalWrap extends React.Component {

	render() {
		const { percentage, onClose } = this.props
		return (
			<div className="modal-wrap">
				<div className="modal-header">
					<h5 className="title">Add an Image</h5>
					<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={ onClose }>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div className="modal-body">
					<div className="progress">
						<div id="uploader" className="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" style={{"width": percentage + "%" }} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
					</div>
					<span className="progress-txt" id="progress-txt">Upload is { percentage }% done</span>
				</div>
			</div>
		)
	}
}

class ModalClose extends React.Component {
	render() {
		const { onClose } = this.props
		return (
			<a className="modal-close" onClick={onClose} >
				<span>
					<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6 4.586l4.24-4.24c.395-.395 1.026-.392 1.416-.002.393.393.39 1.024 0 1.415L7.413 6l4.24 4.24c.395.395.392 1.026.002 1.416-.393.393-1.024.39-1.415 0L6 7.413l-4.24 4.24c-.395.395-1.026.392-1.416.002-.393-.393-.39-1.024 0-1.415L4.587 6 .347 1.76C-.05 1.364-.048.733.342.343c.393-.393 1.024-.39 1.415 0L6 4.587z"></path></svg>
				</span>
			</a>
		)
	}
}

class ImgModal extends React.Component {
	render() {
		
		const { onOverlay, onClose, isOpen, transitionName, percentage } = this.props
		
	    if(isOpen){
			return (
				<TransitionGroup>
					<CSSTransition
					 classNames={transitionName}
					 timeout={{ enter: 200, exit: 200 }}
					>
						<div data-modal="true" onClick={ onOverlay } className="module-modal img-modal" >
							<div data-modal="true" className="modal-wrapper">
								<div className="modal-inner">
									<ModalWrap onClose={ onClose } percentage={ percentage } />
								</div>
							</div>
						</div>	
					</CSSTransition>
				</TransitionGroup>
			);
		} else {
	        return <TransitionGroup classnames={transitionName} />;
	    }
	    
	}
}

export default ImgModal


// WEBPACK FOOTER //
// ./src/components/Modals/ImgModal.js